import { FIELD_COMPONENTS, type FieldComponent } from '@atlas/react-forms';
import CheckboxField from './CheckboxField';
import DateSelectField from './DateSelectField';
import MoneyInput from './MoneyInput';
import PasswordField from './PasswordField';
import PhoneField from './PhoneField';
import SelectField from './SelectField';
import StringField from './StringField';

const fields: Partial<Record<FIELD_COMPONENTS, FieldComponent>> = {
  [FIELD_COMPONENTS.STRING]: StringField,
  [FIELD_COMPONENTS.PASSWORD]: PasswordField,
  [FIELD_COMPONENTS.PHONE]: PhoneField,
  [FIELD_COMPONENTS.SMS_CODE]: StringField,
  [FIELD_COMPONENTS.CHECKBOX]: CheckboxField,
  [FIELD_COMPONENTS.SELECT]: SelectField,
  [FIELD_COMPONENTS.LIST]: SelectField,
  [FIELD_COMPONENTS.CURRENCYPICKER]: SelectField,
  [FIELD_COMPONENTS.DEPOSIT_INPUT]: MoneyInput,
  [FIELD_COMPONENTS.MONEY_INPUT]: MoneyInput,
  [FIELD_COMPONENTS.TIMESTAMP]: DateSelectField,
  [FIELD_COMPONENTS.COMPLEX_PASSWORD]: PasswordField,
};

export default fields;
